<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Sigla modello' : 'Nuova Sigla modello' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-models-form [data]="data"></app-models-form>
</div>
